<template>
  <div class="buy-plan-overlay" v-if="this.$route.query.subId">
    <div class="buy-plan-wrapper">
      {{ getPlan() }}
      {{ getEmployeesCount() }}

      <div class="buy-plan__header">
        <div>
          <h3>Wykup abonament</h3>
          <p>Skonfiguruj plan i przejdź do płatności.</p>
        </div>
        <button
            class="close-btn"
            type="button"
            @click="() => {$router.push($route.path); plan = {}; showSummary = false}"
        >
          <img src="@/assets/icons/x.svg" alt="zamknij">
        </button>
      </div>

      <div class="buy-plan__body buy-plan__body--buy" v-if="!showSummary">
        <div class="selected-plan">
          <span class="field-label">Wybrany plan</span>
          <b>{{ plan.name }}</b>
        </div>

        <label class="form-group" for="usersCount">
          <span>Ilość dodatkowych pracowników</span>
          <input id="usersCount" type="number" min="0" v-model="users" placeholder="Podaj liczbę">
        </label>

        <div class="modal-actions">
          <button
              class="btn-primary"
              type="button"
              @click="() => {users >= 0 ? showSummary = true : appStore.setIsAlert('podaj odpowiednią liczbę pracowników')}"
          >
            Podsumowanie
          </button>
        </div>
      </div>

      <div class="buy-plan__body buy-plan__body--summary" v-if="showSummary">
        <div class="summary-row">
          <span>Opłata abonamentowa</span>
          <b>{{ plan.subscriptionM }} zł × {{ plan.period }} mies. = {{ plan.subscriptionM * plan.period }} zł</b>
        </div>

        <div class="summary-row">
          <span>Opłata za pracownika</span>
          <b>{{ plan.additionalUserM }} zł × {{ users }} = {{ plan.additionalUserM * users }} zł</b>
        </div>

        <div class="summary-row">
          <span>Ilość pracowników w sumie</span>
          <b>{{ users }} + {{ plan.freeUsers }} darmowych = {{ users + plan.freeUsers }}</b>
        </div>

        <div class="summary-row">
          <span>Okres trwania</span>
          <b>{{ plan.period }} mies.</b>
        </div>

        <div class="summary-total">
          <span>Suma</span>
          <b>{{ sum }} zł</b>
        </div>

        <div class="modal-actions modal-actions--space-between">
          <button class="btn-outline" type="button" @click="showSummary = false">
            Wróć
          </button>
          <button class="btn-primary" type="button" @click="pay()">
            Zapłać
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header'
import axios from 'axios'
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default{
  name:'BuyPlanModal',
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    }
  },
  data(){
    return{
        users: 0,
        plan: {},
        showSummary: false,
        sum: 0,
        employeesCount: null
    }
  },
  props:['plans', 'userEmail'],
  computed: {
    currentUser() {
          return this.authStore.user;
      }
  },
  mounted(){
    this.getEmployeesCount()
  },
  methods:{
    getEmployeesCount(){
      if(!this.employeesCount){
        axios.post(`/Users`, {main_id: this.currentUser.id, page: 1, limit: 1}, authHeader())
        .then(res => {
            this.employeesCount = res.data.count
        })
      }
    },
    getPlan(){
      if(this.plan != {} && this.plans.length > 0){
        if(this.$route.query.subId){
            this.plan = this.plans.find(plan => plan.id == this.$route.query.subId)
            this.sum = (this.plan.subscriptionM*this.plan.period)+(this.plan.additionalUserM*this.users)
        }
      }
    },
    pay(){
      if(this.users+this.plan.freeUsers >= this.employeesCount){
        const ob = {
          payment_name: `Opłać plan: ${this.plan.name}`,
          subscription_id: this.plan.id,
          users: this.users,
          buyer_email: this.userEmail,
          only_update: false
        }
        axios.post('/GetPaymentUrl', ob, authHeader()).then(res => {
          window.location.replace(res.data.payment_url)
        }).catch(() => {
          this.appStore.setIsAlert( 'Wystąpił błąd podczas płatności');
        })
      } else if (this.users+this.plan.freeUsers < this.employeesCount) {
        this.appStore.setIsAlert( 'Nie możesz wykupić mniejszej ilości pracowników niż już masz');
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.buy-plan-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(17, 24, 39, .42);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.buy-plan-wrapper {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, .18);
  overflow: hidden;
  font-family: sans-serif;
  box-sizing: border-box;
}

.buy-plan__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.buy-plan__header h3 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
  font-weight: 700;
}

.buy-plan__header p {
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 1.35rem;
}

.close-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: .2s;
  flex-shrink: 0;
}

.close-btn:hover {
  border-color: #10b981;
  background: #f9fafb;
}

.close-btn img {
  width: 18px;
  height: 18px;
}

.buy-plan__body {
  padding: 24px;
}

.buy-plan__body--buy {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.selected-plan {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px;
  background: #fcfcfd;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label,
.form-group span {
  color: #6b7280;
  font-size: 1.3rem;
}

.selected-plan b {
  color: #1f2937;
  font-size: 1.7rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group input {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
  transition: .2s;
}

.form-group input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, .12);
}

.buy-plan__body--summary {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.summary-row,
.summary-total {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 1.4rem;
}

.summary-row span {
  color: #6b7280;
}

.summary-row b {
  color: #1f2937;
  text-align: right;
}

.summary-total {
  margin-top: 4px;
  align-items: center;
  background: #fff7ed;
  border-color: #fed7aa;
}

.summary-total span {
  color: #9a3412;
  font-size: 1.4rem;
  font-weight: 700;
}

.summary-total b {
  color: #9a3412;
  font-size: 2rem;
}

.modal-actions {
  margin-top: 4px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.modal-actions--space-between {
  justify-content: space-between;
}

.btn-primary,
.btn-outline {
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
}

.btn-primary:hover {
  background: #ea6c0a;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 480px) {
  .buy-plan-overlay {
    align-items: flex-start;
    padding: 16px 12px;
  }

  .buy-plan__header,
  .buy-plan__body {
    padding: 16px 12px;
  }

  .buy-plan__header h3 {
    font-size: 1.8rem;
  }

  .summary-row,
  .summary-total {
    flex-direction: column;
    gap: 4px;
  }

  .summary-row b {
    text-align: left;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .modal-actions,
  .modal-actions--space-between {
    justify-content: stretch;
  }
}
</style>